import { render, staticRenderFns } from "./TeamStyle.vue?vue&type=template&id=59d03094&scoped=true&"
import script from "./TeamStyle.vue?vue&type=script&lang=js&"
export * from "./TeamStyle.vue?vue&type=script&lang=js&"
import style0 from "./TeamStyle.vue?vue&type=style&index=0&id=59d03094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d03094",
  null
  
)

export default component.exports